<p-blockUI [blocked]="pageLoading()" />
<app-progress-spinner [enabled]="pageLoading()" />

<div class="header">
  <div class="info">
    <div>
      <label class="created-label"
        >{{ 'MONLOG.LABEL.CREATED_BY' | translate }}:</label
      >
      <span>{{ this.monLog()?.createdBy }}</span>
    </div>
    <div class="status">
      <label>{{ 'MONLOG.LABEL.CURRENT_STATUS' | translate }}:</label>
      @if (monLog()?.logStatus === 'O') {
        <span>{{ 'MONLOG.LABEL.OPEN' | translate }}</span>
      }
      @if (monLog()?.logStatus === 'A') {
        <span>{{ 'MONLOG.LABEL.AWAITING_REVIEW' | translate }}</span>
      }
      @if (monLog()?.logStatus === 'C') {
        <span>{{ 'MONLOG.LABEL.REVIEW_COMPLETE' | translate }}</span>
      }
      @if (monLog()?.logStatus === 'R') {
        <span>{{ 'MONLOG.LABEL.RESOLVED' | translate }}</span>
      }
    </div>
  </div>
  <div>
    <div>
      <label>{{ 'MONLOG.LABEL.LAST_UPDATED' | translate }}:</label>
      <span>{{
        $safeNavigationMigration(this.monLog()?.updatedAt)
          | date: 'MM/dd/yyyy hh:mm:ss a'
      }}</span>
    </div>
    @if (monLog()?.reviewRequestedDt) {
      <div>
        <label>{{ 'MONLOG.LABEL.REVIEW_REQUESTED' | translate }}:</label>
        <span>{{
          $safeNavigationMigration(monLog()?.reviewRequestedDt)
            | date: 'yyyy-MM-dd HH:mm:ss'
        }}</span>
      </div>
    }
    @if (monLog()?.reviewCompletedDt) {
      <div>
        <label>{{ 'MONLOG.LABEL.REVIEW_COMPLETED' | translate }}:</label>
        <span>{{
          $safeNavigationMigration(monLog()?.reviewCompletedDt)
            | date: 'yyyy-MM-dd HH:mm:ss'
        }}</span>
      </div>
    }
    @if (monLog()?.reviewer) {
      <div>
        <label>{{ 'MONLOG.LABEL.REVIEWER' | translate }}:</label>
        <span>{{ monLog()?.reviewer }}</span>
      </div>
    }
    <div>
      <label class="status-label"
        >{{ 'MONLOG.LABEL.STATUS_SUMMARY' | translate }}:</label
      >
      <span>{{ this.monLog()?.statusSummary }}</span>
    </div>
  </div>
  @if (!pageLoading()) {
    <form [formGroup]="monLogForm">
      @if (
        this.monLog()?.logCategory === 'M' || this.monLog()?.logCategory === 'A'
      ) {
        <p-panel
          [showHeader]="true"
          header="{{ 'MONLOG.LABEL.CALL_INFORMATION' | translate }}"
          [toggleable]="true"
          [toggler]="'header'"
        >
          <p-card header="{{ 'MONLOG.LABEL.CALL_INFORMATION' | translate }}">
            <div class="row">
              <label>{{ 'MONLOG.LABEL.TYPE_OF_CALL' | translate }}:</label>
              <input type="text" pInputText formControlName="typeOfCalls" />
            </div>
            <div class="row">
              <label>{{ 'MONLOG.LABEL.WORK_TYPE' | translate }}:</label>
              <input type="text" pInputText formControlName="workTypes" />
            </div>
          </p-card>
          <p-card
            header="{{ 'MONLOG.LABEL.CALLER_LOCATION_INFO' | translate }}"
          >
            <div class="row">
              <label
                >{{ 'MONLOG.LABEL.INTERNAL_CONTACT_ONE' | translate }}:</label
              >
              <input type="text" pInputText formControlName="internalOne" />
            </div>
            <div class="row">
              <label
                >{{ 'MONLOG.LABEL.INTERNAL_CONTACT_TWO' | translate }}:</label
              >
              <input type="text" pInputText formControlName="internalTwo" />
            </div>
          </p-card>
          <p-card header="{{ 'MONLOG.LABEL.FACILITY_INFO' | translate }}">
            <div formGroupName="Facility">
              <div class="row">
                <label>{{ 'LOCATION.LABEL.FACILITY_TYPE' | translate }}:</label>
                <input type="text" pInputText formControlName="facilityType" />
              </div>
              <div class="row">
                <label>{{ 'LOCATION.LABEL.FACILITY_NAME' | translate }}:</label>
                <input type="text" pInputText formControlName="facilityName" />
              </div>
              <div class="row">
                <label>{{ 'LOCATION.LABEL.FACILITY_UID' | translate }}:</label>
                <input type="text" pInputText formControlName="facilityUid" />
              </div>
              <div class="row">
                <label>{{ 'LOCATION.LABEL.AOR' | translate }}:</label>
                <input type="text" pInputText formControlName="aor" />
              </div>
              <div class="row">
                <label>{{ 'COMMON.LABEL.BUSINESS_UNITS' | translate }}:</label>
                <input type="text" pInputText formControlName="businessUnit" />
              </div>
            </div>
          </p-card>
          <p-card
            header="{{ 'MONLOG.LABEL.PRIMARY_CONTACT_INFO' | translate }}"
          >
            @for (
              contact of getContactsControls();
              track contact.getRawValue();
              let i = $index
            ) {
              <p-card>
                <div class="input-row">
                  <label for="primary" class="contact-label">{{
                    'MONLOG.LABEL.PRIMARY_CONTACT' | translate
                  }}</label>
                  <span>{{
                    contact['controls']?.primary.value.primaryFullName
                  }}</span>
                  <label class="contact-label">{{
                    'MONLOG.LABEL.BUSINESS_MOBILE' | translate
                  }}</label>
                  @if (
                    contact['controls']?.primary?.value.primaryBusinessMobile
                  ) {
                    <a
                      href="tel:9-1-{{
                        contact['controls']?.primary?.value
                          .primaryBusinessMobile
                      }}"
                    >
                      {{
                        contact['controls']?.primary.value
                          ?.primaryBusinessMobile
                      }}</a
                    >
                  } @else {
                    Mobile Not Found.
                  }
                </div>
                <div class="input-row">
                  <label for="supervisor" class="contact-label">{{
                    'MONLOG.LABEL.SUPERVISOR' | translate
                  }}</label>
                  <span>{{
                    contact['controls']?.primary.value.supervisorFullName
                  }}</span>
                  <label class="contact-label">{{
                    'MONLOG.LABEL.BUSINESS_MOBILE' | translate
                  }}</label>
                  @if (
                    contact['controls']?.primary?.value.supervisorBusinessMobile
                  ) {
                    <a
                      href="tel:9-1-{{
                        contact['controls']?.primary.value
                          ?.supervisorBusinessMobile
                      }}"
                    >
                      {{
                        contact['controls']?.primary.value
                          ?.supervisorBusinessMobile
                      }}</a
                    >
                  } @else {
                    Mobile Not Found.
                  }
                </div>
                <div class="input-row">
                  <label for="manager" class="contact-label">{{
                    'MONLOG.LABEL.MANAGER' | translate
                  }}</label>
                  <span>{{
                    contact['controls']?.primary?.value.managerFullName
                  }}</span>
                  <label class="contact-label">{{
                    'MONLOG.LABEL.BUSINESS_MOBILE' | translate
                  }}</label>
                  @if (
                    contact['controls']?.primary?.value.managerBusinessMobile
                  ) {
                    <a
                      href="tel:9-1-{{
                        contact['controls']?.primary.value
                          ?.managerBusinessMobile
                      }}"
                    >
                      {{
                        contact['controls']?.primary.value
                          ?.managerBusinessMobile
                      }}</a
                    >
                  } @else {
                    Mobile Not Found.
                  }
                </div>
              </p-card>
            }
          </p-card>
          <p-card header="{{ 'MONLOG.LABEL.ACTIONS_TAKEN' | translate }}">
            @for (entry of monLog()?.MonLogEntries; track entry.id) {
              <div class="entry">
                <app-log-entry [entry]="entry" />
              </div>
            } @empty {
              No Actions to Show.
            }
          </p-card>
        </p-panel>
      } @else {
        <p-panel
          [showHeader]="true"
          header="Call Information"
          [toggleable]="true"
          [toggler]="'header'"
        >
          <p-card header="Call Information">
            <div class="row">
              <label>{{ 'MONLOG.LABEL.TYPE_OF_CALL' | translate }}:</label>
              <input type="text" pInputText formControlName="typeOfCalls" />
            </div>
            <div class="input-row">
              <div class="input-row">
                <label for="customerOutage" class="input-label"
                  >{{ 'MONLOG.LABEL.CUSTOMER_OUTAGE' | translate }}:</label
                >
                <p-checkbox [binary]="true" formControlName="customerOutage" />
              </div>
              <div class="input-row">
                <label class="input-label"
                  >{{ 'MONLOG.LABEL.CALLOUT_REQUIRED' | translate }}:</label
                >
                <p-checkbox [binary]="true" formControlName="calloutRequired" />
              </div>
              <div class="input-row">
                <label for="calloutRequired" class="input-label"
                  >{{ 'MONLOG.LABEL.FALSE_ALARM' | translate }}:</label
                >
                <p-checkbox [binary]="true" formControlName="falseAlarm" />
              </div>
            </div>
            <div class="row">
              <label for="timeBegan"
                >{{ 'MONLOG.LABEL.TIME_BEGAN' | translate }}:</label
              >
              <span>{{
                $safeNavigationMigration(this.monLog()?.timeBegan)
                  | date: 'MM/dd/yyyy hh:mm:ss a'
              }}</span>
            </div>
            <div class="row">
              <label for="timeOnSite"
                >{{ 'MONLOG.LABEL.TIME_ON_SITE' | translate }}:</label
              >
              <span>{{
                $safeNavigationMigration(this.monLog()?.timeOnSite)
                  | date: 'MM/dd/yyyy hh:mm:ss a'
              }}</span>
            </div>
            <div class="row">
              <label for="oneCallNumber"
                >{{ 'MONLOG.LABEL.ONE_CALL_NO' | translate }}:</label
              >
              <input type="text" pInputText formControlName="oneCallNumber" />
            </div>
            <div class="row">
              <label for="ticketNumber"
                >{{ 'MONLOG.LABEL.TICKET_NUMBER' | translate }}:</label
              >
              <input type="text" pInputText formControlName="ticketNumber" />
            </div>
            @if (showGasReleaseType()) {
              <div class="row">
                <label for="gasReleaseType"
                  >{{ 'MONLOG.LABEL.GAS_RELEASE_TYPE' | translate }}:</label
                >
                <input
                  type="text"
                  pInputText
                  formControlName="gasReleaseType"
                />
              </div>
            }
            @if (showSeverity()) {
              <div class="row">
                <label for="commFailSeverity"
                  >{{ 'MONLOG.LABEL.SEVERITY' | translate }}:</label
                >
                <input
                  type="text"
                  pInputText
                  formControlName="commFailSeverity"
                />
              </div>
            }
            @if (showNotam()) {
              <div class="row">
                <label for="notam"
                  >{{ 'MONLOG.LABEL.NOTAM' | translate }}:</label
                >
                <input type="text" pInputText formControlName="notam" />
              </div>
            }
            <div class="row">
              <label for="expireDt"
                >{{ 'MONLOG.LABEL.EXPIRE_DT' | translate }}:</label
              >
              <span>{{
                $safeNavigationMigration(this.monLog()?.expireDt)
                  | date: 'MM/dd/yyyy hh:mm:ss a'
              }}</span>
            </div>
          </p-card>
          <p-card
            header="{{ 'MONLOG.LABEL.CALLER_LOCATION_INFO' | translate }}"
          >
            <div class="row">
              <label>Name:</label>
            </div>
            <div class="row">
              <label for="phone">{{ 'MONLOG.LABEL.PHONE' | translate }}:</label>
              <input type="text" pInputText formControlName="phone" />
            </div>
            <div class="row">
              <label for="street"
                >{{ 'MONLOG.LABEL.STREET' | translate }}:</label
              >
              <input type="text" pInputText formControlName="street" />
            </div>
            @if (monLog()?.logCategory === 'I') {
              <div class="row">
                <label
                  >{{ 'MONLOG.LABEL.INTERNAL_CONTACT_ONE' | translate }}:</label
                >
                <input type="text" pInputText formControlName="internalOne" />
              </div>
              <div class="row">
                <label
                  >{{ 'MONLOG.LABEL.INTERNAL_CONTACT_TWO' | translate }}:</label
                >
                <input type="text" pInputText formControlName="internalTwo" />
              </div>
            }
            <div class="row">
              <label for="state"
                >{{ 'LOCATION.LABEL.STATE' | translate }}:</label
              >
              <input type="text" pInputText formControlName="state" />
            </div>
            <div class="row">
              <label for="county"
                >{{ 'LOCATION.LABEL.COUNTY' | translate }}:</label
              >
              <input type="text" pInputText formControlName="county" />
            </div>
            <div class="row">
              <label for="township"
                >{{ 'LOCATION.LABEL.TOWNSHIP' | translate }}:</label
              >
              <input type="text" pInputText formControlName="township" />
            </div>
            <div class="row">
              <label for="city">{{ 'LOCATION.LABEL.CITY' | translate }}:</label>
              <input type="text" pInputText formControlName="city" />
            </div>
          </p-card>
          <p-card header="{{ 'MONLOG.LABEL.FACILITY_INFO' | translate }}">
            <div formGroupName="Facility">
              <div class="row">
                <label for="facilityType"
                  >{{ 'LOCATION.LABEL.FACILITY_TYPE' | translate }}:</label
                >
                <input type="text" pInputText formControlName="facilityType" />
              </div>
              <div class="row">
                <label for="facilityName"
                  >{{ 'LOCATION.LABEL.FACILITY_NAME' | translate }}:</label
                >
                <input type="text" pInputText formControlName="facilityName" />
              </div>
              <div class="row">
                <label for="facilityUid"
                  >{{ 'LOCATION.LABEL.FACILITY_UID' | translate }}:</label
                >
                <input type="text" pInputText formControlName="facilityUid" />
              </div>
              <div class="row">
                <label for="pipeline"
                  >{{ 'MONLOG.LABEL.PIPELINE' | translate }}:</label
                >
                <input type="text" pInputText formControlName="pipeline" />
              </div>
              <div class="row">
                <label for="aor">{{ 'LOCATION.LABEL.AOR' | translate }}:</label>
                <input type="text" pInputText formControlName="aor" />
              </div>
              <div class="row">
                <label>{{ 'COMMON.LABEL.BUSINESS_UNITS' | translate }}:</label>
                <input type="text" pInputText formControlName="businessUnit" />
              </div>
            </div>
          </p-card>
          <p-card
            header="{{ 'MONLOG.LABEL.PRIMARY_CONTACT_INFO' | translate }}"
          >
            @for (
              contact of getContactsControls();
              track contact.getRawValue();
              let i = $index
            ) {
              <p-card>
                <div class="input-row">
                  <label for="primary" class="contact-label">{{
                    'MONLOG.LABEL.PRIMARY_CONTACT' | translate
                  }}</label>
                  <span>{{
                    contact['controls']?.primary.value.primaryFullName
                  }}</span>
                  <label class="contact-label">{{
                    'MONLOG.LABEL.BUSINESS_MOBILE' | translate
                  }}</label>
                  @if (
                    contact['controls']?.primary?.value.primaryBusinessMobile
                  ) {
                    <a
                      href="tel:9-1-{{
                        contact['controls']?.primary?.value
                          .primaryBusinessMobile
                      }}"
                    >
                      {{
                        contact['controls']?.primary.value
                          ?.primaryBusinessMobile
                      }}</a
                    >
                  } @else {
                    Mobile Not Found.
                  }
                </div>
                <div class="input-row">
                  <label for="supervisor" class="contact-label">{{
                    'MONLOG.LABEL.SUPERVISOR' | translate
                  }}</label>
                  <span>{{
                    contact['controls']?.primary.value.supervisorFullName
                  }}</span>
                  <label class="contact-label">{{
                    'MONLOG.LABEL.BUSINESS_MOBILE' | translate
                  }}</label>
                  @if (
                    contact['controls']?.primary.value?.supervisorBusinessMobile
                  ) {
                    <a
                      href="tel:9-1-{{
                        contact['controls']?.primary.value
                          ?.supervisorBusinessMobile
                      }}"
                    >
                      {{
                        contact['controls']?.primary.value
                          ?.supervisorBusinessMobile
                      }}</a
                    >
                  } @else {
                    Mobile Not Found.
                  }
                </div>
                <div class="input-row">
                  <label for="manager" class="contact-label">{{
                    'MONLOG.LABEL.MANAGER' | translate
                  }}</label>
                  <span>{{
                    contact['controls']?.primary?.value.managerFullName
                  }}</span>
                  <label class="contact-label">{{
                    'MONLOG.LABEL.BUSINESS_MOBILE' | translate
                  }}</label>
                  @if (
                    contact['controls']?.primary.value?.managerBusinessMobile
                  ) {
                    <a
                      href="tel:9-1-{{
                        contact['controls']?.primary.value
                          ?.managerBusinessMobile
                      }}"
                    >
                      {{
                        contact['controls']?.primary.value
                          ?.managerBusinessMobile
                      }}</a
                    >
                  } @else {
                    Mobile Not Found.
                  }
                </div>
              </p-card>
            }
          </p-card>
        </p-panel>
        <p-panel
          [showHeader]="true"
          header="Entries"
          [toggleable]="true"
          [collapsed]="true"
          [toggler]="'header'"
        >
          @for (entry of monLog()?.MonLogEntries; track entry.id) {
            <div class="entry">
              <app-log-entry [entry]="entry" />
            </div>
          } @empty {
            No Entries to Show.
          }
        </p-panel>
      }
      @if (isAlarm()) {
        <p-panel
          [showHeader]="true"
          header="Alarms"
          [toggleable]="true"
          [collapsed]="true"
          [toggler]="'header'"
        >
          @for (alarm of monLog()?.MonLogAlarms; track alarm.id) {
            <div class="entry">
              <app-log-entry [entry]="alarm" />
            </div>
          } @empty {
            No Alarms to Show.
          }
        </p-panel>
      }
      <p-panel
        [showHeader]="true"
        header="{{ 'MONLOG.LABEL.NOTIFICATIONS_AND_AUDIT' | translate }}"
        [toggleable]="true"
        [collapsed]="true"
        [toggler]="'header'"
      >
        <p-card header="{{ 'MONLOG.LABEL.CALLOUT_INFORMATION' | translate }}">
          @for (
            callout of monLog()?.MonLogCallouts;
            track callout;
            let j = $index
          ) {
            <p-card>
              <ng-template #title
                >{{ callout?.firstName }} {{ callout?.lastName }}</ng-template
              >
              <div class="row">
                <label for="startDt">{{
                  'MONLOG.LABEL.CALLOUT_DATE' | translate
                }}</label>
                <span>{{
                  $safeNavigationMigration(callout?.startDt)
                    | date: 'MM/dd/yyyy hh:mm:ss a'
                }}</span>
              </div>
              <div class="row">
                <label for="endDt">{{
                  'MONLOG.LABEL.RETURN_DATE' | translate
                }}</label>
                <span>{{
                  $safeNavigationMigration(callout?.endDt)
                    | date: 'MM/dd/yyyy hh:mm:ss a'
                }}</span>
              </div>
            </p-card>
          } @empty {
            No Information to Show.
          }
        </p-card>
        <p-card header="{{ 'MONLOG.LABEL.NOTIFICATIONS' | translate }}">
          @for (a of monLog()?.MonLogNotifications; track a.time) {
            <div class="entry">
              <strong
                >{{ a.time | date: 'yyyy-MM-dd HH:mm:ss' }} -
                {{ a.user }}:</strong
              >
              {{ a.note }}
            </div>
          } @empty {
            No Notifications to Show.
          }
        </p-card>
        <p-card header="{{ 'MONLOG.LABEL.AUDIT_LOG' | translate }}">
          @for (a of monLog()?.MonLogAudits; track a.time) {
            <div class="entry">
              <strong
                >{{ a.time | date: 'yyyy-MM-dd HH:mm:ss' }} -
                {{ a.user }}:</strong
              >
              {{ a.note }}
            </div>
          } @empty {
            No Audited Logs to Show.
          }
        </p-card>
      </p-panel>
      @if (canViewEventReview() && doesAnyTypeRequireReview()) {
        <p-panel
          [showHeader]="true"
          header="{{ 'MONLOG.LABEL.EVENT_REVIEW' | translate }}"
          [toggleable]="true"
          [collapsed]="true"
          [toggler]="'header'"
        >
          @for (
            entry of monLog()?.ControlRoomEventReviewEntries;
            track entry.id
          ) {
            <div class="entry">
              <app-log-entry [entry]="entry" />
            </div>
          } @empty {
            No Events to Show.
          }
        </p-panel>
      }
    </form>
  }
</div>
